import {IAvailableLlmTool} from '@toolify/server/src/controllers/UserController/validators/GetAvailableLlmTools/types/IGetAvailableLlmToolsRequestInterfaces'
import {LlmToolCategoryType} from '@toolify/server/src/services/LlmService/enum/LlmToolCategoryType'

export function isReadOnlyLlmTool(tool: Pick<IAvailableLlmTool, 'category'>): boolean {
  return tool.category === LlmToolCategoryType.Read
}
